import Dexie, { Table } from 'dexie';

export interface SyncRequest {
  id: string; // usually the URL
  request: any; // can be serialized body or object you reconstruct later
}

export class SyncDBManager extends Dexie {
  requests!: Dexie.Table<SyncRequest, string>;

  constructor() {
    super('SyncDatabase');
    const vesselSyncDbVersion = (<any>window)["appenv"].indexedDBConfig?.vesselSyncDbVersion ?? 1; 
    this.version(vesselSyncDbVersion).stores({
      'bg-sync-api-store': 'id', 
    });

    this.requests = this.table('bg-sync-api-store')
  }

  request = {
    addRequest: async (request: SyncRequest) => {
        return await this.requests.put(request);
    },
    getAllRequests: async () => {
        return await this.requests.toArray();
    },
    deleteRequest: async (id: string) => {
        return await this.requests.delete(id);
    },
    deleteAll: async () => {
        return await this.requests.clear();
    }
  }
}

const syncDbInstance = new SyncDBManager();

export const getSyncDb = (): SyncDBManager => syncDbInstance;